import { render, staticRenderFns } from "./NicheOrderDetail.vue?vue&type=template&id=230f145e"
import script from "./NicheOrderDetail.vue?vue&type=script&lang=js"
export * from "./NicheOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./NicheOrderDetail.vue?vue&type=style&index=0&id=230f145e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports